import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initBoards from '~/boards';

new ShortcutsNavigation(); // eslint-disable-line no-new
initBoards();
